import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { first, firstValueFrom, Subject, takeUntil } from 'rxjs';
import { TreeNodeComponent } from '@shared/components/tree-node/tree-node.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { CountryService } from '@shared/services/country.service';
import { TranslateModule } from '@ngx-translate/core';
import {
  ModuleControllerService,
  ModuleItem,
  SubModuleItem,
} from '@soctrip/angular-banner-service';
import { BannerFormService } from '@shared/services/banner-form.service';
import { AppRoutes } from 'src/app/config/routes.config';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from '@env/environment';
import { Location } from '@angular/common';
import { PermissionService } from 'src/app/core/services/permission/permission.service';
import { NoPermissionComponent } from '@shared/components/no-permission/no-permission.component';
import { HeaderLibModule } from '@soctrip-common/master-menu';
import { UserService } from 'src/app/core/services/user/user.service';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    FormsModule,
    TranslateModule,
    /* primeng */
    DropdownModule,
    /* components */
    TreeNodeComponent,
    NoPermissionComponent,
    HeaderLibModule,
  ],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  providers: [ModuleControllerService],
  encapsulation: ViewEncapsulation.None,
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  public router = inject(Router);
  private countryService = inject(CountryService);
  public permissionService = inject(PermissionService);
  private unsubscribe$ = new Subject<void>();
  environment = environment;
  countries: any[];
  treeData: ModuleItem[] = [];
  selectedCountry: any;
  treeModule = this.route.snapshot.paramMap.get('nameModule') ?? undefined;
  adminModule = AppRoutes.ADMIN;
  listCountryAssigned: String[] = [];
  private destroy$ = new Subject<void>();
  permissionList: string[] = [];
  hasPermission = false;
  moduleList: ModuleItem[] = [];
  marketplace: any;

  constructor(
    private moduleService: ModuleControllerService,
    private bannerFormService: BannerFormService,
    private route: ActivatedRoute,
    private userService: UserService,
    private location: Location
  ) {
    environment.baseURL = environment.BE_API_URL;
  }
  user: any;
  private ngxPermissionService = inject(NgxPermissionsService);

  ngOnInit(): void {
    this.userService.getUserProfile().subscribe((user) => {
      this.user = user;
    });
    this.countryService
      .getlistCountryAssigned()
      .pipe(takeUntil(this.destroy$))
      .subscribe((countries) => {
        this.listCountryAssigned = countries;
      });

    this.ngxPermissionService.permissions$.subscribe((permissions) => {
      this.permissionList = Object.keys(permissions);
      if (this.moduleList.length > 0) {
        this.initTree(this.moduleList);
      } else {
        this.fetchTreeList();
      }
      this.hasPermission = this.permissionService.getCurrentPermission();
    });
    this.route.queryParams.pipe(first()).subscribe((params) => {
      if (params['marketplace']) {
        this.marketplace = params['marketplace'];
        const accessToken = localStorage.getItem(environment.TOKEN_KEY) || '';
        this.selectedCountry = this.marketplace;
        this.countryService.setCountry(this.marketplace);
        this.permissionService.checkPermission1(accessToken, this.marketplace);
      }
    });
    // this.fetchCountryList();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async fetchCountryList() {
    this.countries = await firstValueFrom(this.countryService.getRegion());
    this.selectedCountry = this.countries[0];
    this.countryService.setCountry(this.countries[0]?.country_code);
  }

  fetchTreeList() {
    this.moduleService
      .getAll()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.moduleList = res.data ?? [];
            this.initTree(res.data ?? []);
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  initTree(data: ModuleItem[]) {
    if (this.treeModule && this.treeModule !== this.adminModule) {
      this.treeData =
        data?.filter(
          (node) => node.name?.toUpperCase() === this.treeModule?.replaceAll('-', '_').toUpperCase()
        ) || [];
    } else {
      this.treeData = data || [];
    }
    this.bannerFormService.setTreeData(data as any[]);
  }

  // async handleChangeCountry(event: DropdownChangeEvent) {
  //   const accessToken = localStorage.getItem(environment.TOKEN_KEY) || '';
  //   this.selectedCountry = event.value;
  //   this.countryService.setCountry(event.value.country_code);

  //   const res = await this.permissionService.checkPermission1(
  //     accessToken,
  //     event.value.country_code
  //   );
  // }
  async changeMarketplace(event: any) {
    const accessToken = localStorage.getItem(environment.TOKEN_KEY) || '';
    this.selectedCountry = event.root;
    this.countryService.setCountry(event.root);

    const res = await this.permissionService.checkPermission1(accessToken, event.root);
  }

  nodeSelectEventHandle(node: SubModuleItem) {
    if (this.treeModule) {
      const url = `/${this.treeModule}/${node?.code?.replaceAll('_', '-').toLowerCase()}${
        this.marketplace ? '?marketplace=' + this.marketplace : ''
      }`;
      this.router.navigateByUrl(url);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

interface DropdownChangeEvent {
  originalEvent: Event;
  value: any;
}
